import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

// Approved-device token (MobileGate) lets the backend enforce employee↔device binding.
api.interceptors.request.use((config) => {
    const tok = typeof window !== "undefined" ? window.localStorage.getItem("meyar_device_token") : null;
    if (tok) config.headers["X-Device-Token"] = tok;
    return config;
});

// Redirect to /subscribe when backend responds 402 with subscription_required.
api.interceptors.response.use(
    (r) => r,
    (error) => {
        const status = error?.response?.status;
        const detail = error?.response?.data?.detail;
        const code = detail && typeof detail === "object" ? detail.code : null;
        if (status === 402 && code === "subscription_required") {
            if (typeof window !== "undefined" && window.location.pathname !== "/subscribe") {
                window.location.replace("/subscribe");
            }
        }
        return Promise.reject(error);
    }
);

export function formatApiError(detail) {
    if (detail == null) return "حدث خطأ ما، حاول مجدداً.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" • ");
    }
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
